import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'ambassadors',
		path: '/ambassadors',
		component: loadable(async () => import(/* webpackChunkName: "pages/ambassadors-landing" */ './index'), {
			exportName: 'Ambassadors',
			fallback: Loading,
		}),
		frame: {
			header: false,
			footer: true,
		},
		ssr: {
			enabled: true,
			seo: true,
		},
	},
];
